import {IPreviewProps} from "./Preview";

export function ImagePreview({path}: IPreviewProps) {
    return (
        <img alt={path} src={path}/>
    );
}
